const STORAGE_KEY = "microlab-presentation-image-source";
const PREFER_KEY = "microlab-presentation-prefer-own-images";
const EVENT = "microlab-presentation-image-source";

export const IMAGE_SOURCES = ["private", "public", "both"];

export function normalizeImageSource(value) {
  return IMAGE_SOURCES.includes(value) ? value : "both";
}

export function getPresentationImageSource() {
  try {
    return normalizeImageSource(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return "both";
  }
}

export function getPreferOwnImages() {
  try {
    return window.localStorage.getItem(PREFER_KEY) !== "0";
  } catch {
    return true;
  }
}

export function setPresentationImageSource(value) {
  const next = normalizeImageSource(value);
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Preference still applies for this page session via the event.
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
  return next;
}

export function setPreferOwnImages(value) {
  try {
    window.localStorage.setItem(PREFER_KEY, value ? "1" : "0");
  } catch {
    // Preference still applies for this page session via the event.
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: getPresentationImageSource() }));
  return value !== false;
}

export function subscribePresentationImageSource(listener) {
  const onEvent = (event) => listener(normalizeImageSource(event.detail));
  const onStorage = (event) => {
    if (event.key === STORAGE_KEY) listener(normalizeImageSource(event.newValue));
  };
  window.addEventListener(EVENT, onEvent);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT, onEvent);
    window.removeEventListener("storage", onStorage);
  };
}
